import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import { isEmpty, uniqueId } from 'lodash';
import { styled } from '@mui/system';
import { convertMoney } from '@/utils/convertMoney';
import { style } from '@/styles/globals';
import airportVn from '@/mappings/airport_vn.json';
import { Box, Button, Stack } from '@mui/material';
import { pr } from '@/utils/pxToRem';
import WideTableCellCenter from '@/components/WideTableCellCenter';
import FlexTableRow from '@/components/FlexTableRow';
import ShowNoDataDescription from '@/components/ShowNoDataDescription';
import { format } from 'date-fns';
import { ReserveButton } from './ReserveButton';
import { removeVietnameseTones } from '@/utils/stringConvert';

const CTABooking = styled('div')`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  text-align: center; 
  color: ${style.color.product3};
  cursor:pointer;
`;
const StyledPriceText = styled('div')`
  font-weight: bold;
`;

const StyledText = styled('div')`
`;

// const FlexTableRow = styled(FlexTableRow)`
//   &:nth-of-type(odd) {
//     background-color: ${style.color.white3};
//   }
// `;
export default function AirportToCityTable({
  onSelectTrip, cheapestTripAirport, isDesktop, lang,
}: any) {
  return (
    <TableContainer
      component={Paper}
      sx={{
        minHeight: '50px',
        boxShadow: 'none',
      }}
    >
      <Table
        sx={{ }}
        aria-label="simple table"
      >
        <TableHead>
          <FlexTableRow sx={{ background: 'white' }}>
            <WideTableCellCenter
              align="center"
            >
              {lang?.AirportToCity?.departure || 'Điểm đi'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.AirportToCity?.arrival || 'Điểm đến'}
            </WideTableCellCenter>
            <WideTableCellCenter
              sx={{ whiteSpace: 'nowrap' }}
              align="center"
            >
              {lang?.AirportToCity?.cheapestPrice || 'Gía rẻ nhất'}
            </WideTableCellCenter>
          </FlexTableRow>
        </TableHead>
        <TableBody>
          {!isEmpty(cheapestTripAirport) ? cheapestTripAirport?.map((row: any) => {
            const departCity = row?.city?.stateName;
            const toCity = row?.toCity?.stateName;
            return (
              <FlexTableRow
                key={uniqueId()}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <WideTableCellCenter>
                  <StyledText>
                    {lang?.lang === 'en' ? removeVietnameseTones(departCity) : departCity}
                  </StyledText>
                </WideTableCellCenter>
                <WideTableCellCenter>
                  <StyledText>
                    {lang?.lang === 'en' ? removeVietnameseTones(toCity) : toCity}
                  </StyledText>
                </WideTableCellCenter>
                <WideTableCellCenter align="center">
                  <Stack>
                    <StyledPriceText>
                      {convertMoney(row.total_price_adult, lang)}
                    </StyledPriceText>
                    <ReserveButton
                      onClick={() => onSelectTrip && onSelectTrip(row)}
                      lang={lang}
                    />
                  </Stack>

                </WideTableCellCenter>
              </FlexTableRow>
            );
          })
            : <Box sx={{ p: pr`16px` }}><ShowNoDataDescription lang={lang} /></Box>}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
